<template>
  <div>
    <TeJobUnityCover />

    <TeJobAbout>
      <template #title>
        Unity
      </template>
      <template #content>
        <p class="co-display-10 mb-3 text-co-gray-500">
          Unityを中心とした学習プログラムにおいて
          <br class="hidden md:block">
          受講生の「わからない」をリモートにてサポートしていただきます。
          <br class="hidden md:block">
          あなたのスキルを受講生の成長に活かしてみませんか？
        </p>
        <a href="/job">
          テックアカデミーのメンターについて
        </a>
      </template>
    </TeJobAbout>

    <TeJobTarget />

    <TeJobMessage>
      <template #mentoringText>
        1回30分のビデオチャットで受講生からの相談や質問に答えていただきます。
        <br class="hidden md:block">
        時にはペアプログラミングなどのサポートをしていただきます。
        <br class="hidden md:block">
        マンツーマンメンタリングはカリキュラムやチャットで解決できなかった課題を確実に解消させる取り組みです。
      </template>
      <template #chatsupportText>
        15時〜23時の間のシフト制で、
      </template>
    </TeJobMessage>

    <TeJobWorkStyle />

    <TeJobMentor>
      <template #mentorOne>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-tomiyasu.png"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Keita Tomiyasu"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Keita Tomiyasu
          </h4>
          <p>
            Unity業務歴5年以上、ゲームアプリケーション制作にクライアントエンジニアとして携わる。Unityの隅々まで細かく、幅広い知識を所有。更に最新技術のキャッチアップ能力を強みとしています。
          </p>
        </div>
      </template>
      <template #mentorTwo>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-akiyama.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Yoichi Akiyama"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Yoichi Akiyama
          </h4>
          <p>
            15年ほど前から独学でプログラミングを学び専門学校を卒業後、ゲーム会社に就職し開発に携わる。フリーランスとして独立した後、受託や常駐でUnity製のソーシャルゲームなど様々な案件に関わっている。
          </p>
        </div>
      </template>
    </TeJobMentor>

    <TeJobMentorSlider />

    <!-- スキル -->
    <section
      id="skill"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pb-[3.75rem] pt-20 lg:pb-10">
        <h2 class="co-heading-2">
          Unityメンターに必要なスキル
        </h2>
        <div class="grid grid-cols-1 justify-center gap-9 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-10">
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-unity.png"
                alt="Unity"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Unity
            </template>
            <template #description>
              Unityを用いたゲーム開発・リリースの経験
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faGamepad"
                class="h-12 w-[3.25rem] text-black"
              />
            </template>
            <template #title>
              iOS/Androidゲームアプリ開発経験
            </template>
            <template #description>
              iOS/Androidでのゲームアプリ開発経験（2年以上）
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-c-sharp.png"
                alt="C#"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              C#
            </template>
            <template #description>
              C#を用いた実務経験
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-github.png"
                alt="Git/Github"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Git/Github
            </template>
            <template #description>
              Gitの基礎知識とGitHub上でのソースコード管理経験
            </template>
          </TeJobSkill>
        </div>
      </div>
    </section>

    <TeJobFlow />

    <TeJobEntry course-name-path="unity" />
  </div>
</template>

<script setup lang="ts">
import { metaTags } from '~/utility/constants/metaTags'

import TeJobUnityCover from '~/components/Te/TeJob/Unity/TeJobUnityCover.vue'
import TeJobAbout from '~/components/Te/TeJob/TeJobAbout.vue'
import TeJobTarget from '~/components/Te/TeJob/TeJobTarget.vue'
import TeJobMessage from '~/components/Te/TeJob/TeJobMessage.vue'
import TeJobWorkStyle from '~/components/Te/TeJob/TeJobWorkStyle.vue'
import TeJobMentor from '~/components/Te/TeJob/TeJobMentor.vue'
import TeJobMentorSlider from '~/components/Te/TeJob/TeJobMentorSlider.vue'
import TeJobSkill from '~/components/Te/TeJob/TeJobSkill.vue'
import TeJobFlow from '~/components/Te/TeJob/TeJobFlow.vue'
import TeJobEntry from '~/components/Te/TeJob/TeJobEntry.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faGamepad } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

useJobHead()

useHead({
  title: 'Unity講師（メンター）募集 |テックアカデミー',
  meta: [
    ...metaTags({
      description:
        '受講生をサポートするUnityメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterTitle: 'Unity講師（メンター）募集',
      twitterDescription:
        '受講生をサポートするUnityメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterImage: '_nuxt/ogp/og-image-mentor-unity.jpg',
      ogTitle: 'Unity講師（メンター）募集',
      ogDescription:
        '受講生をサポートするUnityメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      ogUrl: '/job/unity',
      ogImage: '_nuxt/ogp/og-image-mentor-unity.jpg',
    }),
  ],
})
</script>
